import { CircleAlert, X } from "lucide-react";
import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
import "./hinweise.css";

type Hinweis = { id: number; text: string; art: "info" | "fehler"; aktion?: { text: string; ausfuehren: () => void } };
type Zeige = (h: Omit<Hinweis, "id" | "art"> & { art?: Hinweis["art"] }) => void;

const Kontext = createContext<Zeige>(() => {});

export const useHinweis = () => useContext(Kontext);

let zaehler = 0;

export function HinweisBereich({ children }: { children: ReactNode }) {
  const [liste, setListe] = useState<Hinweis[]>([]);
  const weg = useCallback((id: number) => setListe((l) => l.filter((h) => h.id !== id)), []);
  const zeige = useCallback<Zeige>(
    (h) => {
      const id = ++zaehler;
      setListe((l) => [...l.slice(-2), { ...h, art: h.art ?? "info", id }]);
      window.setTimeout(() => weg(id), h.aktion ? 8000 : 5000);
    },
    [weg],
  );
  const wert = useMemo(() => zeige, [zeige]);
  return (
    <Kontext.Provider value={wert}>
      {children}
      <div className="hinweise" role="status" aria-live="polite" aria-label="Meldungen">
        {liste.map((h) => (
          <div key={h.id} className={`hinweis hinweis-${h.art}`}>
            {h.art === "fehler" && <CircleAlert size={14} aria-hidden="true" />}
            <span>{h.text}</span>
            {h.aktion && (
              <button
                type="button"
                className="hinweis-aktion"
                onClick={() => {
                  h.aktion!.ausfuehren();
                  weg(h.id);
                }}
              >
                {h.aktion.text}
              </button>
            )}
            <button type="button" className="hinweis-zu" aria-label="Hinweis schließen" onClick={() => weg(h.id)}>
              <X size={13} aria-hidden="true" />
            </button>
          </div>
        ))}
      </div>
    </Kontext.Provider>
  );
}
